import React, { useEffect, useState } from "react";
import "./Category.css";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import DataTable from "react-data-table-component";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, AlertTitle, LinearProgress,Switch } from "@mui/material";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import CAlertBox from '../CAlertBox/CAlertBox';


const SubCategory = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [subCategorySearch, setSubCategorySearch] = useState([]);

  const [openAdd, setopenAdd] = useState(false);
  const [openAddMssg, setOpenAddMssg] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [categories, setCategories] = useState([]);

  const [idDelete, setIdDelete] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [openDeleteMssg, setOpenDeleteMssg] = useState(false);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [idEdit, setIdEdit] = useState([]);
  const [editName, setEditName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [openUpdateMssg, setOpenUpdateMssg] = useState(false);

  const [loading, setLoading] = useState(true);

  const [checked, setChecked] = useState(true);
  const [alertMessage, setAlertMessage] = useState('');

  const [errMessage, setErrorMessage] = useState(null);
  const [errMessageEdit, setErrorMessageEdit] = useState(null);

  const columns = [
    {
      name: "Id",
      selector: (row) => row.subCategoryId,
      width: "70px",
      sortable: true,
    },
    {
      name: "SubCategory",
      selector: (row) => row.subCategoryName,
    },
    {
      name: "Category",
      selector: (row) => row.categoryName,
    },
    checked ? 
    {name: "Action",
    cell: (row) => (
      <>
        <ModeEditIcon onClick={() => handleEditClick(row)} />
        <p className="seperation-field">  </p>
        <DeleteOutlineIcon onClick={() => handleDeleteClick(row.subCategoryId)} />
      </>
    ),
    tesxtAlign: 'end',
    } : 
    {name: "Action",
    cell: (row) => (
      <>
        <ModeEditIcon onClick={() => handleEditClick(row)} />
      </>
    ),
    tesxtAlign: 'end',
    },
  ];

  useEffect(() => {
    if(!checked){
      axiosApiInstance
      .get(`/subCategory?isactive=${checked}`)
      .then((res) => {
        setSubCategory(res.data.data);
        setLoading(false);
        setSubCategorySearch(res.data.data);
      })
      .catch((err) => console.log(err));
    }
    else{
      axiosApiInstance
      .get(`/subCategory?isactive=${checked}`)
      .then((res) => {
        setSubCategory(res.data.data);
        setLoading(false);
        setSubCategorySearch(res.data.data);
      })
      .catch((err) => console.log(err));

    }
    
  }, [openDelete,openAdd,isOpenEdit,checked]);

  useEffect(() => {
    axiosApiInstance
      .get(`/category`)
      .then((resp) => setCategories(resp.data.data));
  }, []);

  useEffect(() => {
    if(name != '' && description != '' && categoryId != 0){
      setErrorMessage(null);
    }

    if(editName != '' && editDescription != ''){
      setErrorMessageEdit(null);
    }
  }, [name, description, categoryId, editName, editDescription]);

  const handleClickAddOpen = () => {
    setName('');
    setDescription('');
    setCategoryId(0)
    setErrorMessage(null)
    setopenAdd(true);
  };

  const handleAddClose = () => {
    setopenAdd(false);

  };

  const inputEvent = (event) => {
    setCategoryId(event.target.value);
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (name.length > 50) {
      setErrorMessage('SubCategory Name should not be more than 50 characters.');
      return; // Prevent closing the dialog
  }
    if(name === '' || description === '' || categoryId === 0){
      setErrorMessage("Please enter missing fields")
    }else{
      let data = {
        categoryId:categoryId,
          name: name,
          description: description,
        };
        axiosApiInstance.post("/subCategory", JSON.stringify(data)).then((res) => {
          if (res.data.succeeded === true) {
            setopenAdd(false);
            setOpenAddMssg(true);
          } else {
            setopenAdd(false);
            setTimeout(() => {
              setAlertMessage(res.data.message && res.data.message);
            }, 500);
          }
        });
    } 
  };

  const handleDeleteClick = (id) => {
    console.log(id)
    setIdDelete(id);
    setOpenDelete(true);
  };

  const handleDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleDelete = () => {
    axiosApiInstance
      .delete(`/subCategory/${idDelete}`)
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setSubCategory(
            subCategory.filter((x) => x.subCategoryId !== idDelete)
          );
          setOpenDelete(false);
          setOpenDeleteMssg(true);
        }else {
          setopenAdd(false);
          setTimeout(() => {
            setAlertMessage(res.data.message && res.data.message);
          }, 500);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };


  const handleEditClick = (id) => {
    setIdEdit(id);
    setEditName(id.subCategoryName)
    setEditDescription(id.description)
    setErrorMessageEdit(null)
    setIsOpenEdit(true);
  };

  const handleEditClose = () => {
    setIsOpenEdit(false);
  };



  const handleUpdate = (e) => {
    let updateData = JSON.stringify({
      id: idEdit.subCategoryId,
      name: editName,
      description: editDescription,
      isActive: checked ? true : true,
    });

    if(editName === '' || editDescription === ''){
      setErrorMessageEdit("Please enter missing fields")
    }else{
      axiosApiInstance.patch("/subCategory", updateData).then((res) => {
        if (res.data.succeeded === true) {
          setIsOpenEdit(false);
          setOpenUpdateMssg(true)
        }else {
          setopenAdd(false);
          setTimeout(() => {
            setAlertMessage(res.data.message);
          }, 500);
        }
      });
    }
  };

  useEffect(() => {
    const result = subCategory.filter((catg) => {
      return catg?.name?.toLowerCase().match(searchTerm.toLowerCase());
    });
    setSubCategorySearch(result);
  }, [searchTerm]);


  const OnSwitchChange = (e) => {
    setChecked(e.target.checked);
    setLoading(true)
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <AllTicketsHeader
        searchKeyword={searchHandler}
        term={searchTerm}
      
      />
      <SideBar />
      <div className="category-container">
      <div className="toggle-category">
      <div className="switch-category">
               <p>InActive SubCategory</p>
              <Switch onChange={OnSwitchChange} checked={checked} />
            <p>Active SubCategory</p>
            </div>
        <div className="add-category">
          <Button onClick={handleClickAddOpen}>
            <span>+</span>ADD
          </Button>
        </div>
        </div>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openAddMssg}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenAddMssg(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              New subCategory added successfully!
            </Alert>
          </Collapse>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openDeleteMssg}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenDeleteMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Deleted successfully!
            </Alert>
          </Collapse>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openUpdateMssg}>
            {
              checked ?
              (
                <>
                <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenUpdateMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Updated successfully!
            </Alert>
                </>
              ):
              (<>
              <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenUpdateMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Reactived category successfully!
            </Alert>

              </>)
            }
            
          </Collapse>
        </Box>

        {
  !checked ?(<>
  {loading ? (
          <LinearProgress />
        ) : (
          <>
            <DataTable
              columns={columns}
              data={subCategorySearch}
              selectableRowsHighlight
              highlightOnHover
              pagination
              pointerOnHover
              paginationPerPage={7}
            />
          </>
        )}
  </>) 
  :
  (<>
    {loading ? (
            <LinearProgress />
          ) : (
            <>
              <DataTable
                columns={columns}
                data={subCategorySearch}
                selectableRowsHighlight
                highlightOnHover
                pagination
                pointerOnHover
                paginationPerPage={7}
              />
            </>
          )}
    </>) 
  

}

        

        <Dialog open={openAdd} onClose={handleAddClose}>
          <DialogTitle className="category-title">
            Create New SubCategory
          </DialogTitle>
          <DialogContent>
            
                <div className="add-filed">
                 <FormControl sx={{ m: 1, width: "30ch" }}>
              <Select
                displayEmpty
                name="category"
                value={categoryId}
                onChange={inputEvent}
              >
                <MenuItem value="0" disabled>
                  Select*
                </MenuItem>
                {categories.map((cat, id) => (
                  <MenuItem key={id} value={cat.id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
             </FormControl>
             
             <FormControl sx={{ m: 1, width: "30ch" }}>
              <TextField
                required
                id="outlined-required"
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              </FormControl>
              <FormControl sx={{ m: 1, width: "30ch" }}>
              <TextField
                required
                id="outlined-textarea"
                label="Description"
                multiline
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              </FormControl>
               
              </div>
              <Box sx={{ paddingLeft: "10px" }}> {errMessage && (
                  <label style={{ color: "red" }}>{errMessage}</label>
                )}</Box>
          </DialogContent>
          <DialogActions>
            <Button className="save-category" onClick={handleSave}>
              Save
            </Button>
            <Button className="close-category" onClick={handleAddClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDelete}
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to delete ? "}
          </DialogTitle>
          <DialogActions>
            <Button className="save-category" onClick={handleDelete}>
              DELETE
            </Button>
            <Button className="close-category" onClick={handleDeleteClose}>
              CANCEL
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={isOpenEdit}
          onClose={handleEditClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {
            checked ?
            (
              <>
              <DialogTitle className="category-title">Update SubCategory</DialogTitle>
          <DialogContent>
          <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
                 
              <TextField
                id="outlined-required"
                label="Name"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
              />
            
             
              <TextField
                id="outlined-textarea"
                label="Description"
                multiline
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
              />
              </Box>
          </DialogContent>
          <Box sx={{ textAlign: "center" }}> {errMessageEdit && (
                  <label style={{ color: "red" }}>{errMessageEdit}</label>
                )}</Box>
          <DialogActions>
            <Button className="save-category" onClick={handleUpdate}>
              SAVE
            </Button>
            <Button className="close-category" onClick={handleEditClose}>
              CANCEL
            </Button>
          </DialogActions>
              </>
            ):
            (<>
              <DialogTitle className="category-title">Do you want to re-active Category ?</DialogTitle>
            <DialogActions>
              <Button className="save-category" onClick={handleUpdate}>
                YES
              </Button>
              <Button className="close-category" onClick={handleEditClose}>
                NO
              </Button>
            </DialogActions>
            </>)
          }
          
        </Dialog>


      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />

    </>
  );
};

export default SubCategory;
